module.exports = __webpack_public_path__ + "bf0743adaa726b8201bd1312d354998c.svg";